import {
  selectBuildingsDamage,
  selectCitiesCache,
  selectCurrentPlayer,
  selectHexes,
  selectSpecialBuildings,
  selectUnits
} from "../../redux/reducers/sharedStateReducer/selectors";
import {checkIfHexBlockedByEnemyUnit} from "./checkIfHexBlockedByEnemyUnit";
import {checkIfOwner} from "./checkIfOwner";
import {TOKENS} from "../../constants/tokens";
import {checkIfFinalRound} from "../checkIfFinalRound";

/**
 * Проверяет, может ли казарма использоваться для найма нового отряда
 * @param hexKey - hex hexKey
 * @param state - Redux state
 * @returns {boolean}
 */
export const checkIfBarracksCanRecruitNewUnit = (hexKey, state) => {
  // В последнем раунде найм новых отрядов запрещен (клик по казарме отвечает
  // тостом — см. GameScene), поэтому и подсвечивать казармы как доступные для
  // найма незачем: подсветка обещала бы действие, которого нет
  if (checkIfFinalRound(state)) {
    return false;
  }

  const citiesCache = selectCitiesCache(state);
  const hexes = selectHexes(state);
  const currentPlayer = selectCurrentPlayer(state);
  const units = selectUnits(state);
  const buildingsDamage = selectBuildingsDamage(state);
  const specialBuildings = selectSpecialBuildings(state);

  const playerColor = currentPlayer.color;

  let isPlayerBarracks = checkIfOwner(hexKey, playerColor, citiesCache)

  if (!isPlayerBarracks) {
    return false;
  }

  // Проверяем, не занята ли казарма отрядом игрока
  const isOccupiedByPlayerUnit = units.some(u => u.hexKey === hexKey && u.ownerId === currentPlayer.id);
  if (isOccupiedByPlayerUnit) {
    return false;
  }

  // Проверяем, не заблокирована ли казарма вражеским отрядом
  return !checkIfHexBlockedByEnemyUnit(hexKey, TOKENS.BARRACKS, currentPlayer.id, units, hexes, specialBuildings, buildingsDamage);
};
